import { SocialMedia } from "@/app/(pages)/partnership/sign-in/schema";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type Blog = {
  title: string;
  url: string;
  rssFeed: string;
};

type SocialMediaObject = {
  type: string;
  id: string;
  followersCount: number;
};

type FormData = {
  firstName: string;
  lastName: string;
  homeLocation: string;
  bio: string;
  category: string[]; // Add categories field as an array of strings
  blog?: Blog; // Add blog field as an array of Blog objects
  social: SocialMediaObject[]; // Add social field as an array of SocialMedia objects
};

type FormStore = {
  formData: FormData;
  isAgreed: boolean;
  currentStep: number;
  setIsAgreed: (isAgreed: boolean) => void;
  setFormData: (data: Partial<FormData>) => void;
  setStep: (step: number) => void;
  restForm: () => void;
};

export const useFormStore = create<FormStore>()(
  persist(
    (set) => ({
      formData: {
        firstName: "",
        lastName: "",
        homeLocation: "",

        workLocations: ["london"],
        bio: "",
        category: [], // Initialize categories as an empty array
        social: [{ type: SocialMedia.INSTAGRAM, id: "", followersCount: 0 }], // Initialize social with a single default object
      },
      currentStep: 1,
      restForm: () =>
        set((state) => ({
          currentStep: 1,
          formData: {
            firstName: "",
            lastName: "",
            homeLocation: "",
            bio: "",
            category: [], // Initialize categories as an empty array
            social: [
              { type: SocialMedia.INSTAGRAM, id: "", followersCount: 0 },
            ], // Initialize social with a single default object
          },
        })),
      isAgreed: false,
      setIsAgreed: (data) =>
        set((state) => ({
          isAgreed: data,
        })),
      setFormData: (data) =>
        set((state) => ({
          formData: { ...state.formData, ...data },
        })),
      setStep: (step) => set({ currentStep: step }),
    }),
    {
      name: "form-store", // This is the key for storing data in localStorage/sessionStorage
      getStorage: () => localStorage, // You can change this to `sessionStorage` if needed
    },
  ),
);
